angular.module('qkr').controller('beneficiaryController', ($scope,  beneficiariesService, $uibModal,  messageService,
														   outletInfo, sessionService, gettextCatalog, appConfig, $rootScope) => {
	$scope.beneficiaryCustomFields = [];
	$scope.loaded = false;
	$scope.categories = [];
	$scope.showNotificationDiv = true;
	$scope.merchantId = null;
	$scope.init = function() {
		$scope.isActingOnBehalf = false;
		$scope.loadMerchantType();
		//only use the session merchant id if a supplier is acting on behalf of a school
		if((sessionService.getMerchantSessionId() != null) && $scope.isActingOnBehalf === true){
			$scope.merchantId = sessionService.getMerchantSessionId();
		}
		if($scope.isSchool){
		 	beneficiariesService.createProfileOptions($scope.merchantId).then((response) => {
				$scope.profileOptions = response;
			}, reason =>
			 messageService.error(gettextCatalog.getString('A problem was encountered. Please try again.')));
			$scope.loadBeneficiaryCustomField();
			$scope.loadMerchant($scope.merchantId);
		} else if($scope.isSupplier){
			$scope.loadAccessibleSchools($scope.merchantId);
		}
	};

	$scope.loadManagedByIdEmpty = function() {
		if($scope.merchant.managedByMerchant === undefined) {
			$scope.isManagedByIdEmpty = true;
		} else {
			$scope.isManagedByIdEmpty = false;
		}
	}

	$scope.loadMerchantType = function() {
		$scope.isSchool = false;
		$scope.isSupplier = false;
		const businessCategory = outletInfo.businessCategoryName;

		if (outletInfo) {
			$scope.isSchool = businessCategory === 'School';
			$scope.isSupplier = businessCategory === 'Supplier';
		}
	};

	const successRespLoadBeneficiary = (response) => {
		// BeneficiaryCustomFieldDefinition
		$scope.beneficiaryCustomFields = response;
		$scope.viewAbleList = [];
		$scope.nonViewAbleList = [];
		for (let i = 0; i < $scope.beneficiaryCustomFields.length; i++) {
			if ($scope.isShowLine($scope.beneficiaryCustomFields[i])) {
				$scope.viewAbleList.push($scope.beneficiaryCustomFields[i]);
			} else {
				$scope.nonViewAbleList.push($scope.beneficiaryCustomFields[i]);
			}

			if ($scope.beneficiaryCustomFields[i].fieldName.indexOf('InfoAnnualUpdated') !== -1) {
				$scope.showNotificationDiv = false;
			}
		}

		if ($scope.viewAbleList.length > 0) {
			$scope.showWelcome = false;
		} else {
			$scope.showWelcome = true;
		}
		$scope.loaded = true;
	};

	const successRespLoadDepartments = (response) => {
		// BeneficiaryCustomFieldDefinition
		$scope.depsResp = response;
		$scope.deps = [];
		const none = { id: 'none', name: $scope.merchant.name };
		$scope.deps.push(none);
		for(let i = 0; i<response.length; i++){
			const val = { id: response[i].id, name: response[i].name };
			$scope.deps.push(val);
		}
	};

	const successRespLoadSchools = (response) => {
		$scope.accessibleSchools = response;
		$scope.hasSchools = (response && response.length>0);
	};

	const successRespLoadMerchant = (response) => {
		$scope.merchant = response;
		$scope.loadManagedByIdEmpty();
		$scope.loadDepartmentList();
	};

	const errorHandler = () => {
		messageService.error(gettextCatalog.getString('A problem was encountered. Please try again.'));
	};

	$scope.loadDepartmentList = function() {
		// Load all the Beneficiary
		$scope.loadedDepartments = beneficiariesService.loadDepartmentList()
			.then(successRespLoadDepartments, errorHandler);
	};

	$scope.loadAccessibleSchools = function(merchantId) {
		// Load all the schools managed by the supplier
		$scope.accessibleSchools = beneficiariesService.loadAccessibleSchools(merchantId)
			.then(successRespLoadSchools, errorHandler);
	};

	$scope.loadMerchant = function(merchantId) {
		beneficiariesService.loadMerchant(merchantId)
			.then(successRespLoadMerchant, errorHandler);
	};

	$scope.loadBeneficiaryCustomField = function() {
		// Load all the Beneficiary
		beneficiariesService.loadBeneficiaryCustomFields()
			.then(successRespLoadBeneficiary, errorHandler);
	};

	$scope.loadBeneficiaryCustomFieldForMerchant = function(customField) {
		// Load all the Beneficiary
		const successRespLoadBeneficiary = (response) => {
			// BeneficiaryCustomFieldDefinition
			$scope.beneficiaryCustomFields = response;
			$scope.viewAbleList = [];
			$scope.nonViewAbleList = [];
			for (let i = 0; i < $scope.beneficiaryCustomFields.length; i++) {
				if ($scope.isShowLine($scope.beneficiaryCustomFields[i])) {
					$scope.viewAbleList.push($scope.beneficiaryCustomFields[i]);
				} else {
					$scope.nonViewAbleList.push($scope.beneficiaryCustomFields[i]);
				}

				if ($scope.beneficiaryCustomFields[i].fieldName.indexOf('InfoAnnualUpdated') !== -1) {
					$scope.showNotificationDiv = false;
				}
			}
			if ($scope.viewAbleList.length > 0) {
				$scope.showWelcome = false;
			} else {
				$scope.showWelcome = true;
			}
			$scope.loaded = true;
		};
		const errorHandler = () => {

		};
		beneficiariesService.loadBeneficiaryCustomFieldsForMerchant(customField)
			.then((data) => {
					$scope.response = data;
					successRespLoadBeneficiary(data);
				},
				(error) => {
					errorHandler();
				});
	};

	$scope.addBeneficiaryCustomField = function() {
		$scope.openBeneficiaryModal(null, 0);
	};

	$scope.reloadStudentsList = function() {
		$rootScope.$broadcast('reloadDashboard');
		beneficiariesService.invalidateCache();
		$scope.isSupplier=true;
		$scope.isSchool=false;
	};

	$scope.viewSchoolStudentProfile = function(school) {
		$scope.isActingOnBehalf = true;
		$scope.isSchool = true;
		$scope.isSupplier = false;
		$scope.managedSchool = school;
		$scope.profileOptions = beneficiariesService.createProfileOptions($scope.managedSchool.id);
		$scope.loadBeneficiaryCustomFieldForMerchant($scope.managedSchool.id);
	};


	$scope.addBeneficiaryCustomFieldList = function() {
		const fieldChecked = [];
		for (let i = 0; i < $scope.profileOptions.length; i++) {
			if ($scope.profileOptions[i].checked) {
				fieldChecked.push($scope.profileOptions[i].name);
			}
		}

		// Small Validation
		$scope.errors = null;
		const errors = {};
		let valid = true;
		if (fieldChecked.length < 1) {
			errors.addProduct = gettextCatalog.getString('At least one option must be chosen');
			valid = false;
		}
		$scope.errors = errors;

		if (!valid) {
			return;
		}

		$scope.openBeneficiaryModal(fieldChecked, 1);
	};

	$scope.isSupplierChecked = function(dep) {
		if(($scope.isManagedByIdEmpty && dep.id==='none') || $scope.merchant.managedByMerchant.id===dep.id){
			return true;
		}
		return false;
	}

	$scope.grantAccess = function(form) {
		//set the managedby merchant to this id
		if((typeof form.supplier == "string")) { //only update if new selection made
			$scope.updateMerchantManagedBy = beneficiariesService.updateMerchantManagedBy(beneficiariesService.getMerchantResponse(), form.supplier)
				.then(successRespUpdateMerchantManagedBy, errorHandler);
		}
	}

	$scope.editCustomField = function(fieldParam) {
		$scope.openBeneficiaryModal(fieldParam, 2);
	};

	$scope.openBeneficiaryModal = function(fieldParam, mode) {
		const customField = angular.copy(fieldParam);
		$scope.modalOpen = true;

		const modalInstance = $uibModal.open({
			template: require('../templates/beneficiary/beneficiaryDefinitionList.html'),
			controller: 'beneficiaryDefinitionListController',
			windowClass: 'modal-huge',
			backdrop: 'static',
			resolve: {
				customField() {
					return customField;
				},
				listLength() {
					return $scope.beneficiaryCustomFields.length;
				},
				createMode() {
					return mode;
				},
				managedMerchant() {
					return $scope.managedSchool;
				}
			}
		});
		modalInstance.result
			.then((result) => {
				$scope.modalOpen = false;
				if (result === 'ok' || result === 'reload') {
					$scope.loaded = false;
					$scope.reloadFields();
				}
			}, (reason) => {
				messageService.show(reason);
			});
	};

	$scope.buildOptionsLabel = function(options) {
		let returnStr = '';
		angular.forEach(angular.fromJson(options), (value, key) => {
			if (key == 'dropdownOptions') {
				returnStr += String(value).substring(0);
			}
		});
		return returnStr;
	};

	$scope.isShowLine = (customField) => {
		let showLine = true;

		angular.forEach(angular.fromJson(customField.options), (value, key) => {
			if (key === 'hideOnPhone' && value == true) {
				showLine = false;
			}
		});

		if (customField.fieldName.indexOf('InfoAnnualUpdated') !== -1) {
			showLine = false;
		}

		return showLine;
	};

	$scope.removeCustomField = (fieldParam) => {
		const confMsg =
			gettextCatalog.getString('Are you sure you want to delete') +
			'?\'' + fieldParam.fieldLabel + '\'' +
			gettextCatalog.getString('It will no longer be available on Qkr!');

		$scope.modalOpen = true;

		const modalInstance =
			createCommonDialogModalInstance(
				gettextCatalog.getString('Delete') + ' ' + fieldParam.fieldLabel,
				gettextCatalog.getString('Delete'),
				confMsg, []
			);

		modalInstance.result.then((result) => {
			$scope.modalOpen = false;
			if (result === 'ok') {
				let merchantId = null;
				if(!($scope.managedSchool === undefined)){
					merchantId = $scope.managedSchool.id;
				}
				beneficiariesService.deleteCustomFieldForMerchant(merchantId, fieldParam)
					.then(() => {
						$scope.loaded = false;
						$scope.reloadFields();
					}, errorHandler);
			}
		}, () => {
		});
        
	};

	$scope.isStudentProfileRemovable = () => {
        const businessCategory = outletInfo.businessCategoryName;
        const countryIsoCode = outletInfo.country.isoCode;
        if (outletInfo)
		return (countryIsoCode === 'GB' &&
                businessCategory === 'School' &&
				outletInfo.displayStatus === 'LIVE')
	};

	const successRespUpdateBeneficiaries = (response) => {

		messageService.success(gettextCatalog.getString('All parents notified'));

		$scope.sendingNotifications = false;
	};


	const successRespUpdateMerchantManagedBy = (response) => {
		$scope.merchant = response;
		$scope.loadManagedByIdEmpty();
	};

	$scope.updateAll = function() {
		const confMsg =
			gettextCatalog.getString('Are you sure you want to send end of year notications to all parents?');
		$scope.modalOpen = true;
		const modalInstance =
			createCommonDialogModalInstance(
				gettextCatalog.getString('End of Year Update'),
				gettextCatalog.getString('Update'), confMsg, []);
		modalInstance.result.then((result) => {
			$scope.modalOpen = false;

			if (result === 'ok') {
				$scope.sendingNotifications = true;
				let managedSchoolId = null;
				if($scope.managedSchool!=null) {
					managedSchoolId = $scope.managedSchool.id;
				}
				beneficiariesService.updateAll($scope.viewAbleList, $scope.nonViewAbleList, managedSchoolId)
					.then(successRespUpdateBeneficiaries, errorHandler);
			}
		}, (reason) => {
			messageService.show(reason);
		});
	};

	$scope.saveOrder = function() {

		const viewAbleListCopy = angular.copy($scope.viewAbleList);

		$scope.loaded = false;
		$scope.viewAbleList = [];

		for (let i = 0; i < viewAbleListCopy.length; i++) {
			viewAbleListCopy[i].listOrder = i + 1;
		}

		const nonViewAbleListCopy = angular.copy($scope.nonViewAbleList);
		for (let i = 0; i < nonViewAbleListCopy.length; i++) {
			nonViewAbleListCopy[i].listOrder = 0;
		}

		beneficiariesService.updateBeneficiaryOrder(viewAbleListCopy, nonViewAbleListCopy)
			.then( () => {
				$scope.reloadFields();
				$scope.loaded = true;
			}, errorHandler);
	};

	$scope.reloadFields = function() {
		$rootScope.$broadcast('reloadDashboard');
		beneficiariesService.invalidateCache();
		if(($scope.managedSchool === null) || ($scope.managedSchool === undefined)) {
			$scope.loadBeneficiaryCustomField();
		} else {
			$scope.loadBeneficiaryCustomFieldForMerchant($scope.managedSchool.id);
		}
	};

	var createCommonDialogModalInstance = function(title, confirmButtonName, confirmMsg, multiMsgArray) {

		const modalInstance = $uibModal.open({
			template: require('../templates/common/modalDialog.html'),
			controller: 'commonModalDialogController',
			windowClass: 'fade',
			backdrop: 'static',
			resolve: {
				title() {
					return title;
				},
				confirmButtonName() {
					return confirmButtonName;
				},
				confirmMsg() {
					return confirmMsg;
				},
				multiMsgArray() {
					return multiMsgArray;
				}
			}
		});
		return modalInstance;
	};
});



// WEBPACK FOOTER //
// ./src/controllers/beneficiary.controller.js